import React, {ReactElement, useRef} from "react";
import styles from './FileInput.module.scss';


interface ILeftMenuFileItem {
    onFileSelected?: (file: File) => void,
    icon: ReactElement;
    validFileExtensions: string;
    isMultipleSelection: boolean;
    disabledAction?: boolean;
}

export const FileInput: React.FC<ILeftMenuFileItem> = (props) => {

    const inputRef: React.LegacyRef<HTMLInputElement> = useRef(null);


    const onClick = () => {
        inputRef.current?.click();
    }

    const onFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        props.onFileSelected!(file)
    }

    return (
        <>
            <div onClick={onClick} className={`${styles.icon_wrapper} ${Boolean(props.disabledAction) ? styles.disabledAction : ''}`}>
                {props.icon}
            </div>

            <input
                ref={inputRef}

                // must be hidden
                hidden
                disabled={Boolean(props.disabledAction)}
                type="file"
                accept={props.validFileExtensions}

                multiple={props.isMultipleSelection}
                onClick={(e) => {
                    //--------------------------------------------------//
                    // BUG FIX: to select the same file multiple times

                    // bug fix: for chrome
                    if (inputRef.current !== null) {
                        inputRef.current!.value = '';
                    }

                    // bug fix: for firefox
                    return false;
                    //--------------------------------------------------//
                }}
                onChange={onFileSelected}
            />

        </>
    )
}